import { render } from "./chat_message_date.vue?vue&type=template&id=23377998"
import script from "./chat_message_date.vue?vue&type=script&lang=js"
export * from "./chat_message_date.vue?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__